const isMinimum = (value, number) =>
  value && value.length < number && `Este valor deve ter pelo menos ${number} caracteres!`;

export default isMinimum;
